<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <h4>Terminy pracowników</h4>
        </div>
        <div class="widget-content me-2">

		<div class="d-flex align-items-center mb-3">
		  <select v-model="selectedTyp" class="form-select me-2" style="width: auto;" @change="updateFilter">
			<option value="">Wszystkie</option>
			<option v-for="typ in terminy" :key="typ.id" :value="typ.id">{{ typ.nazwa }}</option>
		  </select>

		  <a v-if="selectedTyp" :href="`/kadry/terminy/lista/pdf/${selectedTyp}`" target="_blank" class="btn btn-primary">
			Generuj PDF
		  </a>
		  <a v-else :href="`/kadry/terminy/lista/pdf/0`" target="_blank" class="btn btn-primary">
			Generuj PDF
		  </a>
		</div>

          <div class="custom-table table-responsive">
            <table id="data-table" class="table table-hover table-bordered table-sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Imię i nazwisko</th>
                  <th>Rodzaj terminu</th>
                  <th>Data wykonania</th>
                  <th>Ważność do</th>
                </tr>
                <tr class="filters">
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { onMounted, ref } from "vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

const { hasPermission } = usePermission();

export default {
  components: { AppLayout, hasPermission },
  props: {
    users: Array,
    terminy: Array
  },
  setup(props) {
    const dataTable = ref(null);
    const selectedTyp = ref("");

function updateFilter() {
  if (!dataTable.value) return;
  const table = dataTable.value;

  if (!selectedTyp.value) {
    // Wszystkie – reset filtra
    table.column(2).search("").draw();
  } else {
    const typ = props.terminy.find(t => t.id === parseInt(selectedTyp.value));
    if (typ) {
      table.column(2).search(typ.nazwa).draw();
    }
  }
}

    function initColumnSearch() {
      const table = dataTable.value;
      if (!table) return;

      table.columns().every(function (colIdx) {
        if (colIdx === 0) return;

        const cell = $('.filters th').eq(colIdx);
        const title = $(table.column(colIdx).header()).text();

        $(cell).html(`<input type="text" placeholder="Filtruj ${title}" style="width: 100%;" />`);

        $('input', cell).off('input').on('input', function () {
          if (table.column(colIdx).search() !== this.value) {
            table.column(colIdx).search(this.value).draw();
          }
        });
      });
    }

    onMounted(() => {
      dataTable.value = $("#data-table").DataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [
          [25, 50, 100, -1],
          [25, 50, 100, "Wszystkie"]
        ],
        ajax: {
          url: "/kadry/terminy/tabela",
          type: "GET"
        },
        columns: [
          { width: "3%", data: "index", orderable: true, searchable: false },
          {
            width: "40%", data: "name", name: "name",
            render: function (data, type, row) {
			const canViewWorkersDane = hasPermission('canViewWorkersDane');
			
              let alerts = "";
              let alertIcon = "";
              const today = new Date();
              const dataEnd = new Date(row.data_end);
              const ileWczesniej = parseInt(row.ile_wczesniej);
              const diffDays = Math.ceil((dataEnd.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

              let alertStatus = "";

              if (!isNaN(diffDays) && !isNaN(ileWczesniej)) {
                if (diffDays <= 0) {
                  alertStatus = "termin minął";
                  alertIcon = "⚠️";
                  alerts += `<span class="text-danger text-left ms-2">Termin ważności minął!</span>`;
                } else if (diffDays <= ileWczesniej) {
                  alertStatus = "termin zbliża się";
                  alertIcon = "⚠️";
                  alerts += `<span class="text-warning text-left ms-2">Zbliża się termin ważności!</span>`;
                }
              }

              if (row.user_stanowisko?.toLowerCase() !== row.termin_stanowisko?.toLowerCase()) {
                alertStatus += " stanowisko zmienione";
                alertIcon = "⚠️";
                alerts += `<span class="text-danger text-left ms-2">Zmiana stanowiska!</span>`;
              }

              if(type === 'filter' || type === 'sort') return row.name + " " + alertStatus;
			  
			  let nameHtml = '';

			  if (canViewWorkersDane) {
				nameHtml = `<a href="/kadry/show/user/${row.id}" class="text-primary">
							  <strong>${row.name}</strong>
							</a>`;
			  } else {
				nameHtml = `<strong>${row.name}</strong>`;
			  }
			  

              return `
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <span class="me-1">${alertIcon}</span>
                    ${nameHtml}
                  </div>
                  <div>${alerts}</div>
                </div>
              `;
            }
          },
          { data: "termin_typ", name: "Rodzaj terminu", defaultContent: "" },
          { width: "130px", data: "data_make", name: "Data wykonania", 
            render: function (data) {
              if (!data) return ''; 
              return new Date(data).toLocaleDateString('pl-PL', { year: 'numeric', month: '2-digit', day: '2-digit' });
            }
          },
          { width: "130px", data: "data_end", name: "Ważność do",
            render: function (data) {
              if (!data) return ''; 
              return new Date(data).toLocaleDateString('pl-PL', { year: 'numeric', month: '2-digit', day: '2-digit' });
            }
          }
        ],
        initComplete: function () {
          initColumnSearch();
		  updateFilter();
        },
      });
    });

    return { dataTable, selectedTyp, terminy: props.terminy, updateFilter };
  },
};
</script>

<style>
.text-warning { color: orange; font-weight: bold; }
.text-danger { color: red; font-weight: bold; }
.alert-xs { font-size: 0.75rem; padding: 2px 8px; line-height: 1.1; }
.table-hover tbody tr:hover { background-color: #f1f1f1; }
.alert.alert-danger { color: #a94442; background-color: #f2dede; border-color: #ebccd1; border-radius: 4px; }
.alert.alert-warning { color: #8a6d3b; background-color: #fcf8e3; border-color: #faebcc; border-radius: 4px; }
.text-primary { color: #0d6efd; text-decoration: none; }
.text-primary:hover { text-decoration: underline; }
.widget-six { background: #fff; padding: 1rem; border-radius: 6px; box-shadow: 0 0 15px rgba(0,0,0,0.05); }
.widget-heading h4 { margin-bottom: 1rem; font-weight: 600; }
.filters input { border: 1px solid #ced4da; border-radius: 4px; padding: 4px 8px; font-size: 0.875rem; background-color: #cfcfcf; }
.th { background-color: #cfcfcf; }
</style>
